import JumbotronCarousel from './JumbotronCarousel';

const jumbotronCarouselConfig = {
  name: 'jumbotronCarousel',
  class: JumbotronCarousel,
  querySelectorAll: {
    articles: '.article-post-list__article',
  },
  options: {
    carouselClass: '.jumbotron-homepage__carousel',
    activeSlideClass: 'article-post-list__article--active',
    slick: {
      fade: true,
      speed: 1000,
      waitForAnimate: false,
    },
  },
};

export default jumbotronCarouselConfig;



// WEBPACK FOOTER //
// ./client/js/components/JumbotronCarousel/jumbotronCarouselConfig.js